import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../";

const BusinessFilters = ({
  searchTerm,
  onSearchChange,
  onClearSearch,
  onRefresh,
  isLoading,
}) => {
  const { t } = useTranslation("stores");
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleSearchChange = (e) => {
    onSearchChange(e.target.value);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await onRefresh();
    } finally {
      setIsRefreshing(false);
    }
  };

  const hasActiveSearch = searchTerm.trim() !== "";

  return (
    <div className="rounded-lg border border-gray-800 bg-gray-900 p-4">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        {/* Search Input */}
        <div className="min-w-0 flex-1">
          <div className="relative">
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
              <Icon name="Search" className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              placeholder={t("search.placeholder")}
              value={searchTerm}
              onChange={handleSearchChange}
              className="h-10 w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-2 pr-10 pl-10 text-white placeholder-gray-400 focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
            {searchTerm && (
              <button
                onClick={onClearSearch}
                className="absolute top-1/2 right-2 flex h-5 w-5 -translate-y-1/2 transform cursor-pointer items-center justify-center rounded-full bg-gray-600 transition-colors hover:bg-gray-500"
                type="button"
              >
                <svg
                  className="h-3 w-3 text-gray-300 hover:text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3">
          {/* Clear Search Button */}
          {hasActiveSearch && (
            <button
              onClick={onClearSearch}
              className="inline-flex h-10 items-center rounded-lg border border-gray-700 bg-gray-800 px-3 py-2 text-sm leading-4 font-medium text-gray-300 shadow-sm hover:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none"
            >
              <svg
                className="mr-1 h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              {t("filters.clearSearch")}
            </button>
          )}

          {/* Refresh Button */}
          <button
            onClick={handleRefresh}
            disabled={isLoading || isRefreshing}
            className="inline-flex h-10 items-center rounded-lg border border-transparent bg-blue-600 px-3 py-2 text-sm leading-4 font-medium text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
          >
            <svg
              className={`mr-1 h-4 w-4 ${isRefreshing ? "animate-spin" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            {isRefreshing ? t("filters.refreshing") : t("filters.refresh")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BusinessFilters;
